//Enum with changes allowed in the rule.
export enum ConditionalFormattingModificationType {
    Color,
}
